import HTTP from './HTTPApi';

const URL_BASE = 'auth';

export async function Login(data) {
  const response = await HTTP.post(URL_BASE, data);
  return response;
}

export async function CheckToken() {
  const response = await HTTP.get(`${URL_BASE}/check-token`);
  return response;
}

export async function RequestResetPassword(data) {
  const response = await HTTP.post(`${URL_BASE}/demande-mdp`, data);
  return response;
}

export async function ChangeMdp(id, data) {
  const response = await HTTP.put(`${URL_BASE}/change-mdp/${id}`, data);
  return response;
}

export const NOTHING = '';
